import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { SUPPORTED_LANGS, LANG_LABELS, setCookie, getCookie } from '../i18n';

const LocaleDetector = () => {
  const { i18n, t } = useTranslation();
  const [suggestedLang, setSuggestedLang] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (getCookie('zelina-locale-dismissed')) return;

    const browserLang = navigator.language?.substring(0, 2);
    const currentLang = i18n.language?.substring(0, 2) || 'en';

    if (browserLang && browserLang !== currentLang && SUPPORTED_LANGS.includes(browserLang)) {
      setSuggestedLang(browserLang);
    }
  }, [i18n.language]);

  const accept = () => {
    const currentLang = i18n.language?.substring(0, 2) || 'en';
    const pathWithoutLang = location.pathname.replace(new RegExp(`^/${currentLang}`), '') || '/';
    i18n.changeLanguage(suggestedLang);
    setCookie('zelina-lang', suggestedLang);
    setCookie('zelina-locale-dismissed', '1');
    navigate(`/${suggestedLang}${pathWithoutLang === '/' ? '' : pathWithoutLang}${location.search}`);
    setSuggestedLang(null);
  };

  const dismiss = () => {
    setCookie('zelina-locale-dismissed', '1');
    setSuggestedLang(null);
  };

  if (!suggestedLang) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-6 py-4 rounded-2xl border flex items-center gap-4 max-w-lg"
      style={{
        background: 'var(--bg-elevated)',
        borderColor: 'var(--border)',
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        backdropFilter: 'blur(20px)',
      }}
      data-testid="locale-detector"
    >
      <p className="text-sm flex-1" style={{ color: 'var(--text-secondary)' }}>
        {t('locale_prompt.message', { language: LANG_LABELS[suggestedLang] })}
      </p>
      <button onClick={accept} className="btn-primary !py-2 !px-4 text-sm whitespace-nowrap" data-testid="locale-accept">
        {t('locale_prompt.switch', { language: LANG_LABELS[suggestedLang] })}
      </button>
      <button onClick={dismiss} className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-[var(--gold-muted)] transition-colors" data-testid="locale-dismiss">
        <X className="w-4 h-4" style={{ color: 'var(--text-muted)' }} />
      </button>
    </div>
  );
};

export default LocaleDetector;
